export const SupabaseUrl = {
  Development: 'https://itjtyjmvcfwlwdkuodjz.supabase.co',
  Localhost: 'http://127.0.0.1:54321',
  Production: 'https://xnanfjgntfuxtjdapgut.supabase.co',
} as const;

export type SupabaseUrl = (typeof SupabaseUrl)[keyof typeof SupabaseUrl];
